import { Collapse, Offcanvas } from 'bootstrap'

function handleOffcanvasEvents() {
  const offcanvasOffsetElement = document.querySelector('header')
  const offcanvasButton = document.getElementById('headerOffcanvasButton')
  const offcanvas = document.getElementById('headerOffcanvas')

  if (offcanvasOffsetElement && offcanvasButton && offcanvas) {
    offcanvas.addEventListener('show.bs.offcanvas', event => {
      offcanvasButton.classList.add('offcanvas-open')
      let topOffset = offcanvasOffsetElement.getBoundingClientRect().bottom
      offcanvas.style.top = `${topOffset}px`
    })

    offcanvas.addEventListener('hide.bs.offcanvas', event => {
      offcanvasButton.classList.remove('offcanvas-open')
    })
  }
}

function handleMainNavigationEvents() {
  const mainNavigationCollapses = document.querySelectorAll('.navigation-menu-dropdowns .collapse')
  const mainNavigationItemsContainer = document.querySelectorAll('.main-navigation-items')
  let collapseOpenCount = 0

  if (mainNavigationCollapses && mainNavigationItemsContainer) {
    mainNavigationCollapses.forEach(collapse => {
      collapse.addEventListener('hide.bs.collapse', event => {
        collapseOpenCount--;
        if (collapseOpenCount <= 0) {
          mainNavigationItemsContainer.forEach(container => container.classList.remove('dropdown-open'))
        }
      })
      collapse.addEventListener('show.bs.collapse', event => {
        collapseOpenCount++;
        if (collapseOpenCount > 0) {
          mainNavigationItemsContainer.forEach(container => container.classList.add('dropdown-open'))
        }
      })
    })
  }
}

function handleKeyboardAndMouseEvents() {
  // On escape keypress, collapse all header collapses
  const headerCollapses = document.querySelectorAll('header .collapse, .main-navigation-wrapper .collapse')
  if (headerCollapses) {
    document.addEventListener('keydown', (event) => {
      if (event?.key === 'Escape' || event?.key === 'Esc') {
        headerCollapses.forEach((headerCollapse) => {
          const collapse = Collapse.getOrCreateInstance(headerCollapse, { toggle: false })
          collapse.hide()
        })
      }
    })
  }
  
  // On click outside main navigation, close all main navigation collapses
  const mainNavigationWrappers = Array.from(document.querySelectorAll('.main-navigation'))
  const mainNavigationCollapses = document.querySelectorAll('.main-navigation .collapse')
  if (mainNavigationWrappers && mainNavigationCollapses) {
    document.addEventListener('click', (event) => {
      const clickedMainNavigation = mainNavigationWrappers.some(wrapper => wrapper.contains(event.target))
      if (!clickedMainNavigation) {
        mainNavigationCollapses.forEach((mainNavigationCollapse) => {
          const collapse = Collapse.getOrCreateInstance(mainNavigationCollapse, { toggle: false })
          collapse.hide()
        })
      }
    })
  }

  // On click outside header and main navigation, close header offcanvas
  const header = document.querySelector('header')
  const headerOffcanvas = document.querySelector('#headerOffcanvas')
  const utilitySearchForms = Array.from(document.querySelectorAll('.utility-search-form'))
  if (header && headerOffcanvas) {
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target) && !mainNavigationWrappers.some(wrapper => wrapper.contains(event.target))) {
        const offcanvasInstance = Offcanvas.getOrCreateInstance(headerOffcanvas, { toggle: false})
        offcanvasInstance.hide()
      }
    })
  }
  // On click outside utility search form, deactivate utility search
  if (utilitySearchForms) {
    document.addEventListener('click', (event) => {
      if (utilitySearchForms.every(el => !el.contains(event.target))) {
        utilitySearchForms.forEach(el => {
          el.classList.remove('active')
        })
      }
    })
  }
}

function handleUtilitySearchToggleEvents() {
  const utilitySearchToggleElements = document.querySelectorAll('.utility-search-form-toggle-enabled .utility-search-toggle')
  utilitySearchToggleElements.forEach(utilitySearchToggleElement => {
    utilitySearchToggleElement.addEventListener('click', event => {
      const utilitySearchForm = utilitySearchToggleElement.closest('.utility-search-form')
      if (utilitySearchForm) {
        event.preventDefault()
        const utilitySearchInput = utilitySearchForm.querySelector('.utility-search-input')
        if (utilitySearchForm.classList.contains('active')) {
          if (utilitySearchInput.value) {
            utilitySearchForm.submit();
          } else {
            utilitySearchForm.classList.remove('active')  
          }
        } else {
          utilitySearchForm.classList.add('active')
          utilitySearchInput.focus()
        }
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', (event) => {
  handleOffcanvasEvents()
  handleMainNavigationEvents()
  handleKeyboardAndMouseEvents()
  handleUtilitySearchToggleEvents()
});